<template>
	<div class="sub_contents">
		<div class="cont_center">
			<h1 class="title_page">쇼핑</h1>
		</div>
		<div class="cont_center">
			<ul class="event_list shopping">
				<!-- Dynamic banners from API -->
				<li v-for="(banner, index) in shoppingBanners" :key="index">
					<a href="#" @click.prevent="handleLinkClick(banner)" rel="noopener noreferrer">
						<img :src="makeBannerImageUrl(banner.bannerPath)" :alt="banner.bannerTitle || '쇼핑 배너'"
							@error="handleBannerImageError" />
					</a>
				</li>
			</ul>
		</div>

		<!-- AlertPopup 추가 -->
		<AlertPopup v-model="showLoginAlert" title="알림" class="alert_popup">
			<template #layer_content>
				<div class="alert-content">
					<p>{{ loginAlertMessage }}</p>
					<div class="alert-buttons">
						<button class="btn btn-primary" @click="handleLoginAlertConfirm">확인</button>
						<button class="btn btn-secondary" @click="handleLoginAlertCancel">취소</button>
					</div>
				</div>
			</template>
		</AlertPopup>

		<!-- 약관 팝업 -->
		<div v-if="showTermsPopup" class="layer_bg">
			<div class="layer_popup terms_popup">
				<div class="popup_header">
					<h3>{{ termsData.title || '서비스 이용약관' }}</h3>
					<button type="button" class="btn_close" @click="closeTermsPopup">
						<span class="sr-only">닫기</span>
					</button>
				</div>
				<div class="popup_content">
					<div v-if="isTermsLoading" class="loading_terms">
						<p>약관 정보를 불러오는 중...</p>
					</div>
					<div v-else class="terms_content">
						<div v-if="termsData.content" v-html="termsData.content"></div>
					</div>
				</div>
				<div class="popup_footer">
					<div class="btn_area">
						<button type="button" class="btn_cancel" @click="closeTermsPopup">
							취소
						</button>
						<button type="button" class="btn_confirm" @click="confirmTerms"
							:disabled="isAgreementLoading || isTermsLoading">
							{{ isAgreementLoading ? '처리중...' : '동의' }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getBranchUuid, updatePlatformInfo, getPlatformInfo, getConfig, setConfig } from "@/lib/Config";
import { getAxiosCustom, getAxios, postAxios } from "@/lib/AxiosCall";
import { DEFAULT_NO_IMAGE } from "@/lib/Constant";
import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant";
import { emitter } from '@/lib/eventBus';
import AlertPopup from "@/components/AlertPopup.vue";
import { SessionManager } from '@/lib/SessionManager';
import { useRouter } from "vue-router";

export default {
	components: {
		AlertPopup,
	},

	data() {
		return {
			shoppingBanners: [], // setup()에서 data()로 이동
			showTermsPopup: false,
			pendingBanner: null,
			isAgreementLoading: false,
			isTermsLoading: false,
			isSSOLoading: false,
			termsData: {
				title: '',
				content: '',
				contractType: 'CONTRACT_DFS'
			},
			showLoginAlert: false,
			loginAlertMessage: '',

			// 로그인 팝업 관리
			currentPopup: null,
			popupId: null
		};
	},

	async mounted() {
		// setup()의 onMounted 로직을 mounted()로 이동
		await this.fetchBannerData();
	},

	methods: {
		// Convert relative image path to full URL
		makeBannerImageUrl(imagePath) {
			return imagePath
				? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + imagePath
				: DEFAULT_NO_IMAGE;
		},

		// Handle image loading errors
		handleBannerImageError(event) {
			console.log("쇼핑 배너 이미지 로드 실패");
			event.target.src = DEFAULT_NO_IMAGE;
		},

		// FOODCON SSO 로그인 상태 확인
		isFoodconLoggedIn() {
			const config = getConfig();
			return config &&
				config.user &&
				config.user.isLoggedIn === true &&
				config.user.userInType === 'FOODCON';
		},

		// FOODCON SSO 로그인 처리 함수
		async handleFoodconSSO(platformInfo) {
			try {
				console.log("FOODCON SSO 로그인 처리 시작:", platformInfo);

				const loginData = {
					userInType: 'USER_IN_FOODCON',
					userId: platformInfo.platformUser,
					branchUuid: getBranchUuid()
				};

				console.log("FOODCON SSO 로그인 요청:", loginData);

				const response = await postAxios("/bgm/v1/mem/login", loginData);

				console.log("FOODCON SSO 로그인 응답:", response);

				if (response) {
					const userData = response;

					const currentConfig = getConfig() || {};
					const updatedConfig = {
						...currentConfig,
						user: {
							isLoggedIn: true,
							loginType: 'FOODCON_SSO',
							userInType: 'FOODCON',
							platformType: platformInfo.platformType,
							userId: userData.userId || platformInfo.platformUser,
							userName: userData.userName || '',
							email: userData.email || '',
							phone: userData.phone || '',
							token: userData.token || '',
							refreshToken: userData.refreshToken || '',
							loginDate: new Date().toISOString(),
							platformUser: platformInfo.platformUser,
							platformGroup: platformInfo.platformGroup,
							platformSeq: platformInfo.platformSeq
						},
						platform: {
							...currentConfig.platform,
							...platformInfo
						}
					};

					setConfig(updatedConfig);

					localStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(response));

					if (typeof emitter !== 'undefined') {
						emitter.emit('user-login-changed', {
							isLoggedIn: true,
							userInfo: response
						});
					}

					console.log("FOODCON SSO 로그인 성공 - 사용자 정보 저장:", updatedConfig.user);
					return true;
				} else {
					console.error("FOODCON SSO 로그인 실패: 응답 데이터 없음");
					return false;
				}

			} catch (error) {
				console.error("FOODCON SSO 로그인 처리 실패:", error);

				const currentConfig = getConfig() || {};
				const updatedConfig = {
					...currentConfig,
					user: {
						isLoggedIn: false,
						loginType: 'GUEST',
						userInType: 'GUEST',
						platformType: platformInfo.platformType
					},
					platform: {
						...currentConfig.platform,
						...platformInfo
					}
				};
				setConfig(updatedConfig);

				return false;
			}
		},

		// Fetch banner data from API
		async fetchBannerData() {
			try {
				console.log("쇼핑 배너 데이터 로딩 시작...");

				// 1. URL 파라미터에서 플랫폼 정보 추출 (최초 진입)
				const urlParams = new URLSearchParams(window.location.search);
				let platformType = urlParams.get('platformType');
				let platformUser = urlParams.get('platformUser');
				let platformGroup = urlParams.get('platformGroup');
				let platformSeq = urlParams.get('platformSeq');

				console.log("HFO_SP_001: URL 파라미터 확인", {
					platformType,
					platformUser,
					platformGroup,
					platformSeq,
					hasAllParams: !!(platformType && platformUser && platformGroup && platformSeq)
				});

				// 2. URL 파라미터가 있는 경우 (최초 진입)
				if (platformType && platformUser && platformGroup && platformSeq) {
					console.log("HFO_SP_001: 최초 진입 - URL 파라미터로 처리");

					const platformInfo = {
						platformType,
						platformUser,
						platformGroup,
						platformSeq
					};

					updatePlatformInfo(platformInfo);

					if (platformType === 'FOODCON') {
						console.log("FOODCON 플랫폼 감지 - SSO 로그인 처리");
						const ssoSuccess = await this.handleFoodconSSO(platformInfo);

						if (ssoSuccess) {
							console.log("FOODCON SSO 로그인 성공 - 로그인된 상태로 배너 로드");
						} else {
							console.log("FOODCON SSO 로그인 실패 - 게스트 모드로 배너 로드");
						}
					}

				} else {
					// 3. URL 파라미터가 없는 경우 (다른 메뉴에서 재진입)
					console.log("HFO_SP_001: 재진입 - localStorage hvm_config에서 platform 정보 확인");

					try {
						const hvmConfig = getConfig();

						console.log("HFO_SP_001: hvm_config 확인", hvmConfig);

						if (hvmConfig && hvmConfig.platform) {
							platformType = hvmConfig.platform.platformType;
							platformUser = hvmConfig.platform.platformUser;
							platformGroup = hvmConfig.platform.platformGroup;
							platformSeq = hvmConfig.platform.platformSeq;

							console.log("HFO_SP_001: hvm_config에서 가져온 platform 정보", {
								platformType,
								platformUser,
								platformGroup,
								platformSeq,
								hasAllParams: !!(platformType && platformUser && platformGroup && platformSeq)
							});

							if (platformType && platformUser && platformGroup && platformSeq) {
								console.log("HFO_SP_001: hvm_config에서 완전한 platform 정보 확인 - 로그인 상태도 체크");

								const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
								const isLoggedIn = hvmConfig.user && hvmConfig.user.isLoggedIn === true;

								console.log("HFO_SP_001: 로그인 상태 확인", {
									hasUserInfo: !!userInfoString,
									configLoggedIn: isLoggedIn,
									userInType: hvmConfig.user?.userInType
								});

								if (!isLoggedIn && !userInfoString && platformType === 'FOODCON') {
									console.log("HFO_SP_001: FOODCON 플랫폼 재로그인 시도");

									const platformInfo = {
										platformType,
										platformUser,
										platformGroup,
										platformSeq
									};

									const ssoSuccess = await this.handleFoodconSSO(platformInfo);

									if (ssoSuccess) {
										console.log("HFO_SP_001: FOODCON 재로그인 성공");
									} else {
										console.log("HFO_SP_001: FOODCON 재로그인 실패 - 게스트 모드 유지");
									}
								} else {
									console.log("HFO_SP_001: 로그인 상태 유지 또는 비FOODCON 플랫폼");
								}
							} else {
								console.warn("HFO_SP_001: hvm_config의 platform 정보가 불완전함");
								platformType = null;
								platformUser = null;
								platformGroup = null;
								platformSeq = null;
							}
						} else {
							console.log("HFO_SP_001: hvm_config에 platform 정보 없음 - 일반 모드로 처리");
							platformType = null;
							platformUser = null;
							platformGroup = null;
							platformSeq = null;
						}
					} catch (error) {
						console.error("HFO_SP_001: hvm_config 처리 중 오류", error);
						platformType = null;
						platformUser = null;
						platformGroup = null;
						platformSeq = null;
					}
				}

				// 4. 배너 데이터 API 호출
				const apiParams = {
					branchUuid: getBranchUuid(),
					bannerType: 'BANNER_SHOPPING'
				};

				if (platformType && platformUser && platformGroup && platformSeq) {
					apiParams.platformType = platformType;
					apiParams.platformUser = platformUser;
					apiParams.platformGroup = platformGroup;
					apiParams.platformSeq = platformSeq;

					console.log("HFO_SP_001: platform 정보 포함하여 배너 API 호출", apiParams);
				} else {
					console.log("HFO_SP_001: 일반 모드로 배너 API 호출", apiParams);
				}

				const response = await getAxiosCustom("/hvm/v1/branch/banner", apiParams);

				console.log("HFO_SP_001: 배너 데이터 응답", response);

				if (response && response.data && response.data.page) {
					const list = response.data.page.list || [];

					this.shoppingBanners = list
						.filter((b) => b.bannerType === "BANNER_SHOPPING")
						.sort((a, b) => parseInt(a.order) - parseInt(b.order));

					console.log("HFO_SP_001: 쇼핑 배너 데이터 로드 완료", {
						totalBanners: this.shoppingBanners.length,
						hasPlatformInfo: !!(platformType && platformUser),
						mode: platformType ? `${platformType} 플랫폼 모드` : '일반 모드'
					});
				} else {
					console.error("HFO_SP_001: API 응답 형식이 올바르지 않습니다", response);
				}

			} catch (error) {
				console.error("HFO_SP_001: 배너 데이터 로드 실패", error);
			}
		},

		// MA_001의 handleLinkClickAD와 동일한 로직
		async handleLinkClick(banner) {
			console.log("HFO_SP_001: 배너 클릭됨", banner);

			if (banner.linkType !== 'LINK_NEW') {
				console.log("HFO_SP_001: LINK_NEW가 아님, 기본 처리");
				this.handleDefaultBannerClick(banner);
				return;
			}

			const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
			console.log("HFO_SP_001: 사용자 정보 확인", {
				userInfoString: userInfoString,
				hasInfo: !!userInfoString
			});

			if (!userInfoString) {
				console.log("HFO_SP_001: 로그인 정보 없음 - AlertPopup 표시");
				this.showLoginRequiredAlert();
				return;
			}

			try {
				const userInfo = JSON.parse(userInfoString);
				const userUuid = userInfo.userUuid;

				console.log("HFO_SP_001: 파싱된 사용자 정보", {
					userInfo: userInfo,
					userUuid: userUuid
				});

				if (!userUuid) {
					console.log("HFO_SP_001: userUuid 없음 - AlertPopup 표시");
					this.showLoginRequiredAlert();
					return;
				}

				const targetUrl = this.addUserUuidToUrl(banner.linkUrl, userUuid);

				console.log("HFO_SP_001: userUuid 포함하여 배너 링크 이동", {
					원본URL: banner.linkUrl,
					최종URL: targetUrl,
					userUuid: userUuid
				});

				window.open(targetUrl, '_blank');

			} catch (error) {
				console.error("HFO_SP_001: 사용자 정보 파싱 실패", error);
				this.showLoginRequiredAlert();
			}
		},

		// 로그인 필요 AlertPopup 표시
		showLoginRequiredAlert() {
			console.log("HFO_SP_001: showLoginRequiredAlert 호출됨");

			this.loginAlertMessage = '로그인이 필요한 서비스입니다.\n로그인 페이지로 이동하시겠습니까?';
			this.showLoginAlert = true;

			console.log("HFO_SP_001: AlertPopup 설정 완료", {
				showLoginAlert: this.showLoginAlert,
				loginAlertMessage: this.loginAlertMessage
			});
		},

		// AlertPopup 확인 버튼 클릭 핸들러
		handleLoginAlertConfirm() {
			console.log("HFO_SP_001: AlertPopup 확인 버튼 클릭됨");
			this.showLoginAlert = false;
			// 로그인 팝업 오픈
			this.openLoginPopup();
		},

		// AlertPopup 취소 버튼 클릭 핸들러
		handleLoginAlertCancel() {
			console.log("HFO_SP_001: AlertPopup 취소 버튼 클릭됨");
			this.showLoginAlert = false;
		},

		// URL에 userUuid 파라미터 추가하는 헬퍼 메서드
		addUserUuidToUrl(url, userUuid) {
			if (!url || !userUuid) {
				return url;
			}

			try {
				const urlObj = new URL(url);
				urlObj.searchParams.set('userUuid', userUuid);
				return urlObj.toString();
			} catch (error) {
				console.warn("HFO_SP_001: URL 파싱 실패, 쿼리스트링 방식으로 추가", error);

				const separator = url.includes('?') ? '&' : '?';
				return `${url}${separator}userUuid=${encodeURIComponent(userUuid)}`;
			}
		},

		// 기본 배너 클릭 처리 (LINK_NEW가 아닌 경우)
		handleDefaultBannerClick(banner) {
			console.log("HFO_SP_001: 기본 배너 클릭 처리", banner);

			// dfsAgreeYn 체크
			if (banner.dfsAgreeYn === 'N') {
				console.log("약관 동의 필요 - 약관 동의 전 로그인 체크");

				const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
				console.log("HFO_SP_001: 약관 동의 시 로그인 정보 확인", {
					userInfoString: userInfoString,
					hasInfo: !!userInfoString
				});

				if (!userInfoString) {
					console.log("HFO_SP_001: 약관 동의 전 로그인 정보 없음 - AlertPopup 표시");
					this.showLoginRequiredAlert();
					return;
				}

				try {
					const userInfo = JSON.parse(userInfoString);
					const userUuid = userInfo.userUuid;

					console.log("HFO_SP_001: 약관 동의 시 파싱된 사용자 정보", {
						userInfo: userInfo,
						userUuid: userUuid
					});

					if (!userUuid) {
						console.log("HFO_SP_001: 약관 동의 전 userUuid 없음 - AlertPopup 표시");
						this.showLoginRequiredAlert();
						return;
					}

					console.log("HFO_SP_001: 로그인 상태 확인 완료 - 약관 데이터 로드 및 팝업 표시");
					this.pendingBanner = banner;
					this.showTermsPopup = true;
					this.fetchTermsData();
					return;

				} catch (error) {
					console.error("HFO_SP_001: 약관 동의 시 사용자 정보 파싱 실패", error);
					this.showLoginRequiredAlert();
					return;
				}
			}

			// dfsAgreeYn이 'Y'인 경우 바로 링크 처리
			this.processBannerLink(banner);
		},

		// 배너 링크 처리
		processBannerLink(banner) {
			console.log("HFO_SP_001: 배너 링크 처리", banner);

			if (!banner.linkUrl) {
				console.warn("HFO_SP_001: 배너 링크 URL이 없습니다");
				return;
			}

			let finalUrl = banner.linkUrl;

			if (banner.linkType === 'LINK_NEW') {
				console.log("HFO_SP_001: LINK_NEW 타입 - userUuid 파라미터 추가");

				const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
				if (userInfoString) {
					try {
						const userInfo = JSON.parse(userInfoString);
						const userUuid = userInfo.userUuid;

						if (userUuid) {
							finalUrl = this.addUserUuidToUrl(banner.linkUrl, userUuid);
							console.log("HFO_SP_001: userUuid 추가된 최종 URL", {
								원본URL: banner.linkUrl,
								최종URL: finalUrl,
								userUuid: userUuid
							});
						}
					} catch (error) {
						console.error("HFO_SP_001: processBannerLink에서 userInfo 파싱 실패", error);
					}
				}
			}

			switch (banner.linkType) {
				case 'LINK_SELF':
					window.location.href = finalUrl;
					break;
				case 'LINK_BLANK':
				case 'LINK_NEW':
				default:
					window.open(finalUrl, '_blank');
					break;
			}

			if (banner.brandUuid) {
				this.$router.push({
					name: "BrandDetail",
					params: {
						brandId: banner.brandUuid,
					},
				});
			}
		},

		// 약관 데이터 로딩 함수
		async fetchTermsData() {
			try {
				this.isTermsLoading = true;
				console.log("약관 데이터 로딩 시작 - contractType: CONTRACT_DFS");

				const response = await getAxios("/hvm/v1/help/contract", {
					branchUuid: getBranchUuid(),
					contractType: 'CONTRACT_DFS'
				});

				console.log("약관 데이터 응답:", response);

				if (response) {
					const contract = response.page.list[0];
					this.termsData = {
						title: contract.title || '덴탈몰 정보 동의',
						content: contract.rmks || '',
						contractType: contract.contractType || 'CONTRACT_DFS',
						contractTypeName: contract.contractTypeName || '',
						contractDd: contract.contractDd || ''
					};
					console.log("약관 데이터 로드 완료:", this.termsData.title);
				} else {
					console.warn("약관 데이터가 없습니다. 기본 약관을 사용합니다.");
					this.termsData = {
						title: '덴탈몰 정보 동의',
						content: '',
						contractType: 'CONTRACT_DFS'
					};
				}
			} catch (error) {
				console.error("약관 데이터 로드 실패:", error);
				this.termsData = {
					title: '덴탈몰 정보 동의',
					content: '',
					contractType: 'CONTRACT_DFS'
				};
			} finally {
				this.isTermsLoading = false;
			}
		},

		// 약관 팝업 닫기
		closeTermsPopup() {
			console.log("약관 팝업 닫기");
			this.showTermsPopup = false;
			this.pendingBanner = null;
			this.termsData = {
				title: '',
				content: '',
				contractType: 'CONTRACT_DFS'
			};
		},

		// 약관 동의 처리
		async confirmTerms() {
			if (this.isAgreementLoading || this.isTermsLoading) return;

			try {
				this.isAgreementLoading = true;
				console.log("약관 동의 처리 시작");

				const platformInfo = getPlatformInfo();

				const agreementData = {
					platformType: platformInfo.platformType,
					platformUser: platformInfo.platformUser,
					platformGroup: platformInfo.platformGroup,
					platformSeq: platformInfo.platformSeq,
					dfsAgreeYn: "Y",
					contractType: this.termsData.contractType,
					contractTypeName: this.termsData.contractTypeName,
					contractDd: this.termsData.contractDd
				};

				console.log("약관 동의 API 호출:", agreementData);

				const response = await postAxios("/bgm/v1/mem/contract", agreementData);

				console.log("약관 동의 API 응답:", response);

				this.showTermsPopup = false;

				this.termsData = {
					title: '',
					content: '',
					contractType: 'CONTRACT_DFS'
				};

				if (this.pendingBanner) {
					console.log("약관 동의 완료 - 배너 링크 처리", this.pendingBanner);

					this.pendingBanner.dfsAgreeYn = 'Y';
					this.processBannerLink(this.pendingBanner);
					this.pendingBanner = null;
				}

			} catch (error) {
				console.error("약관 동의 처리 실패:", error);
				alert("약관 동의 처리 중 오류가 발생했습니다. 다시 시도해주세요.");
			} finally {
				this.isAgreementLoading = false;
			}
		},

		routerLink(uuid, replyYn) {
			console.log("이벤트 클릭:", { uuid, replyYn });

			// replyYn이 'Y'인 경우 로그인 체크
			if (replyYn === 'Y') {
				// SessionManager.isSessionValid()로 로그인 상태 확인
				if (!SessionManager.isSessionValid()) {
					// 로그인되지 않은 경우 로그인 필요 알림 표시
					console.log("HFO_SP_001: 댓글 참여 이벤트 - 로그인 필요");
					this.showLoginRequiredAlert();
					return;
				}

				console.log("HFO_SP_001: 로그인 상태 확인됨 - 이벤트 페이지로 이동");
			}

			// 로그인이 필요없거나 로그인된 경우 이벤트 정보 저장하고 이동
			sessionStorage.setItem("eventUuid", uuid);
			sessionStorage.setItem("replyYn", replyYn);
			this.$router.push("/HFO_PR_003");
		},

		// 헤더와 동일한 방식의 로그인 팝업 오픈 (완료 콜백 지원)
		openLoginPopup(onCompleted) {
			try {
				const target = `${window.location.origin}/HFO_LO_001_POP`;
				const popupWidth = 380;
				const popupHeight = 560;
				const left = Math.floor((window.screen.width - popupWidth) / 2);
				const top = Math.floor((window.screen.height - popupHeight) / 2);

				const popupName = `hvm_login_${Date.now()}`;
				const popup = window.open(
					target,
					popupName,
					`width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
				);
				if (!popup) {
					alert('팝업이 차단되었습니다. 팝업 허용 후 다시 시도하세요.');
					return;
				}

				this.currentPopup = popup;
				this.popupId = popupName;

				const messageHandler = (e) => {
					try {
						const origin = String(e.origin || '');
						const allowed = origin === window.location.origin || origin.includes('localhost') || origin.includes('bridgem.hivitamin.co.kr');
						if (!allowed) return;
						const data = e.data || {};
						if (data.type === 'HVM_POPUP_CONTENT_SIZE') {
							const requestedWidth = parseInt(data.width, 10) || popupWidth;
							const requestedHeight = parseInt(data.height, 10) || popupHeight;
							const maxPopupWidth = Math.min(560, Math.max(420, (window.screen?.availWidth || window.innerWidth) - 24));
							const maxPopupHeight = Math.min(980, Math.max(560, (window.screen?.availHeight || window.innerHeight) - 24));
							const newWidth = Math.min(maxPopupWidth, Math.max(320, requestedWidth));
							const newHeight = Math.min(maxPopupHeight, Math.max(popupHeight, requestedHeight));

							if (this.currentPopup && !this.currentPopup.closed && typeof this.currentPopup.resizeTo === 'function') {
								try { this.currentPopup.resizeTo(newWidth, newHeight); } catch (_) { /* noop */ }
							}
							if (this.currentPopup && !this.currentPopup.closed && typeof this.currentPopup.moveTo === 'function') {
								const centerLeft = Math.floor((window.screen.width - newWidth) / 2);
								const centerTop = Math.floor((window.screen.height - newHeight) / 2);
								try { this.currentPopup.moveTo(centerLeft, centerTop); } catch (_) { /* noop */ }
							}
							return;
						}
						if (data.type === 'HVM_LOGIN_COMPLETED') {
							console.log('openLoginPopup: HVM_LOGIN_COMPLETED 수신');
							if (data.user) localStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(data.user));
							if (data.token) sessionStorage.setItem('hvm_token', data.token);
							try { SessionManager.startSession(); } catch (e) { console.warn(e); }
							// 헤더/앱에 로그인 변경 알림
							emitter.emit('user-login-changed', { isLoggedIn: true, userInfo: data.user || null });

							// ACK 전송
							try {
								if (e.source && typeof e.source.postMessage === 'function') {
									e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
								} else if (this.currentPopup && !this.currentPopup.closed) {
									this.currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
								}
							} catch (ackErr) {
								console.warn('ACK failed', ackErr);
								try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this.popupId }, e.origin); } catch (_) { /* noop */ }
							}

							setTimeout(() => { try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (_) { /* noop */ } this.currentPopup = null; this.popupId = null; }, 100);

							// 완료 콜백 실행
							try { if (typeof onCompleted === 'function') onCompleted(); } catch (cbErr) { console.warn('onCompleted error', cbErr); }
						} else if (data.type === 'HVM_LOGIN_NEED_SIGNUP') {
							if (data.userData) sessionStorage.setItem('signup_user_data', JSON.stringify(data.userData));
							try {
								if (e.source && typeof e.source.postMessage === 'function') {
									e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
								} else if (this.currentPopup && !this.currentPopup.closed) {
									this.currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this.popupId }, e.origin);
								}
							} catch (ackErr) {
								console.warn('ACK failed', ackErr);
								try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this.popupId }, e.origin); } catch (_) { /* noop */ }
							}
							setTimeout(() => {
								try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (_) { /* noop */ }
								this.currentPopup = null;
								this.popupId = null;
								const userData = data.userData || {};
								const isKakaoUser = (userData.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
								this.$router.push(isKakaoUser ? '/HFO_MB_004_SNS' : '/HFO_MB_003');
							}, 100);
						} else if (data.type === 'HVM_POPUP_CLOSE_REQUEST') {
							try { if (this.currentPopup && !this.currentPopup.closed) this.currentPopup.close(); } catch (_) { /* noop */ }
							this.currentPopup = null; this.popupId = null;
						}
					} catch (err) {
						console.warn('openLoginPopup messageHandler error', err);
					}
				};

				window.addEventListener('message', messageHandler, false);
				setTimeout(() => { window.removeEventListener('message', messageHandler); }, 10 * 60 * 1000);
			} catch (err) {
				console.error('openLoginPopup error', err);
			}
		}
	},
};
</script>

<style lang="scss" scoped>
// 약관 팝업 스타일
.layer_bg {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.terms_popup {
	background: white;
	border-radius: 8px;
	width: 90%;
	max-width: 500px;
	max-height: 80vh;
	display: flex;
	flex-direction: column;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.popup_header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	border-bottom: 1px solid #eee;

	h3 {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
	}

	.btn_close {
		background: none;
		border: none;
		font-size: 24px;
		cursor: pointer;
		padding: 0;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;

		&::before {
			content: '×';
			font-size: 24px;
			color: #666;
		}

		&:hover::before {
			color: #333;
		}
	}
}

.popup_content {
	flex: 1;
	overflow-y: auto;
	padding: 20px;
}

.loading_terms {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 200px;

	p {
		color: #666;
		font-size: 14px;
	}
}

.terms_content {
	line-height: 1.6;

	:deep(h1),
	:deep(h2),
	:deep(h3),
	:deep(h4),
	:deep(h5),
	:deep(h6) {
		margin-top: 20px;
		margin-bottom: 10px;
		font-weight: 600;
		color: #333;

		&:first-child {
			margin-top: 0;
		}
	}

	:deep(p) {
		margin-bottom: 15px;
		color: #666;
		font-size: 14px;
		line-height: 1.6;
	}

	:deep(ul),
	:deep(ol) {
		margin-bottom: 15px;
		padding-left: 20px;

		li {
			margin-bottom: 5px;
			color: #666;
			font-size: 14px;
			line-height: 1.5;
		}
	}

	:deep(table) {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: 15px;

		th,
		td {
			border: 1px solid #ddd;
			padding: 8px;
			text-align: left;
			font-size: 14px;
		}

		th {
			background-color: #f9f9f9;
			font-weight: 600;
		}
	}
}

.popup_footer {
	padding: 20px;
	border-top: 1px solid #eee;

	.btn_area {
		display: flex;
		gap: 10px;
		justify-content: flex-end;

		button {
			padding: 10px 20px;
			border: none;
			border-radius: 4px;
			cursor: pointer;
			font-size: 14px;
			font-weight: 500;

			&:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}
		}

		.btn_cancel {
			background: #f5f5f5;
			color: #666;

			&:hover:not(:disabled) {
				background: #e0e0e0;
			}
		}

		.btn_confirm {
			background: #007bff;
			color: white;

			&:hover:not(:disabled) {
				background: #0056b3;
			}
		}
	}
}

.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}
</style>
